import * as React from "react";
const SvgArrowLeft = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m4.6 9 6-6L12 4.4 7.4 9l4.6 4.6-1.4 1.4z" }));
export default SvgArrowLeft;
